import React from 'react';
import { useTranslation } from "react-i18next";

const Map = ({text, lat, long}) => {

    const { t } = useTranslation();
    return (
        <div className="row">
            <div className="contact-info">
                <h3>{t("map_title")}</h3>
            </div>
            <div className="col-lg-10 col-12">
                <div id="contact-map">
                    <iframe
                        src={`https://maps.google.com/maps?q=${lat},${long}&hl=es&z=10&output=embed`}
                        title={'Contact Map'}
                        style={{width: '100%', height: '100%', border: 0}}
                    />
                </div>
            </div>
            <div className="contact-availability">
                    <p>{text}</p>
            </div>
        </div>
    );
};

export default Map;